interface IAuthLayoutProps {
  children: React.ReactNode
  header?: React.ReactNode
}

export const AuthLayout = (props: IAuthLayoutProps) => {
  const { children, header } = props
  return (
    <div className='min-h-screen bg-neutral-surface w-full'>
      {header && <header>{header}</header>}
      <main className='md:w-[480px] mx-auto'>{children}</main>
    </div>
  )
}
